// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Inline styles which cannot be styled with JSX */\n.selector-item-hover:focus {\n  box-shadow: 0 0 0 3px #E09D03 !important;\n}\n\n.navbar-button-hover:focus {\n  box-shadow: none !important;\n}\n\n\n/* Customized scrollbar */\n\n::-webkit-scrollbar {\n  width: 4px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  width: 4px;\n  border-radius: 2px;\n  background: #AAC6DE;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #427CAC;\n}", ""]);
// Exports
module.exports = exports;
